import {LineupAnalyzer} from './lineup-analyzer';

class MlbLineupAnalyzer extends LineupAnalyzer {
    protected canPlayerBeConsidered(player): boolean {
        return !isEmpty(player) && !player.isPitcher();
    }
}

export {MlbLineupAnalyzer};
